module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-flow-arrow-down-683adfc97f604bd6ffed1659a27eb2b4.png";